import React from "react";
import firebase from "./../../utils/firebase";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import styles from "./../Theme/Styles";
import PubSub from "pubsub-js";
import { default as Button } from "./../Common/Button";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";

var _self = null;
// Initialize the FirebaseUI Widget using Firebase.
// Configure FirebaseUI.
let uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: "popup",
  // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  callbacks: {
    // Avoid redirects after sign-in.
    signInSuccessWithAuthResult: (AuthResult) => {
      console.log("sign in success");
      console.log(AuthResult);
      _self.props.setState({
        userLoadedCallback: () => {
          _self.redirects(AuthResult);
        },
      });

      _self.props.refreshUserAuth();
    },
    signInFailure: () => {
      console.log("sign in failure");
    },
    tosUrl: "/terms",
  },
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    // firebase.auth.EmailAuthProvider.PROVIDER_ID,
    // firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID,
    {
      provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
      signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
      // requireDisplayName: true
    },
    firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    {
      provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
      recaptchaParameters: {
        size: "invisible", // 'invisible' or 'compact'
      },
    },
  ],
};
var ui =
  firebaseui.auth.AuthUI.getInstance() ||
  new firebaseui.auth.AuthUI(firebase.auth());

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.firebaseUIElement = React.createRef();
    _self = this;
    this.user = props.user;
    // this.redirectUrl = props.redirectUrl ? props.redirectUrl : "/";
    console.log("Redirect Url: " + this.redirectUrl);
    // check for desiredPlanId ids
    this.desiredPlanId = props.desiredPlanId ? props.desiredPlanId : "/";

    props.dispatch({
      type: "ADD_DESIRED_PLAN",
      payload: this.desiredPlanId,
    });
  }

  componentDidMount() {
    document.title = "Login";

    setTimeout(() => {
      ui.start("#firebaseui-auth-container", uiConfig);
    }, 1500);
  }

  componentWillUnmount() {
    window.removeEventListener("load", this.handleLoad);
  }

  handleLoad() {
    if (!_self.user) {
      ui.start("#firebaseui-auth-container", uiConfig);
    }
  }

  redirects(AuthResult) {
    let redirect = true;
    if (AuthResult.user) {
      console.log("login can rent");
      if (
        this.props.searchParams.get("loginType") == "stripe" &&
        this.props.searchParams.get("redirectUrl")
      ) {
        this.props.redirect(this.props.searchParams.get("redirectUrl"), true);
        // this.props.navigate("/" + this.props.searchParams.get("redirectUrl"));
      } else {
        _self.props.canRent(_self.redirectUrl, _self.props.renting);
      }
      redirect = false; // only redirect once
    } else {
      PubSub.subscribe("userTokenLogin", () => {
        console.log("receiving user token");
        if (redirect) {
          _self.props.canRent(_self.redirectUrl, _self.props.renting);
          redirect = false; // only redirect once
          // this.props.makeRedirect();
        }
      });
    }
  }

  render() {
    const { user, classes } = this.props;
    return (
      <div>
        {!user ? (
          <React.Fragment>
            <div>
              <Paper className={classes.paper}>
                <Grid spacing={24}>
                  <Grid item xs={12}>
                    <Grid item xs={12}>
                      <img
                        style={{
                          marginTop: "3%",
                          width: "50%",
                          height: "50%",
                        }}
                        src="https://firebasestorage.googleapis.com/v0/b/rent-a-ball.appspot.com/o/Instagram%20Profile%20Picture.jpg?alt=media&token=2031047a-2a60-428a-8796-8f8ce78ee303"
                        alt="Ball Photo"
                      />
                      <h3 style={{ marginTop: "5%", textAlign: "center" }}>
                        {" "}
                        Start Playing Now!
                      </h3>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        style={{ marginTop: "15px", textAlign: "center" }}
                        variant="h5"
                        gutterBottom
                      >
                        Please Sign Up/Login to continue
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <div
                        ref={this.firebaseUIElement}
                        id="firebaseui-auth-container"
                      ></div>
                    </Grid>
                    {/* <Grid>
											<Button
												size="small"
												style={{ marginTop: '5%' }}
												href="/forgot_password"
												className={classes.button}
											>
												Forgot Password(Email Accounts)
											</Button>
										</Grid> */}
                  </Grid>
                </Grid>
              </Paper>
            </div>
          </React.Fragment>
        ) : (
          <div style={{ textAlign: "center" }}>
            <Typography style={{ marginTop: "50%" }} variant="h4">
              You are already logged in{" "}
            </Typography>

            <Button
              size="large"
              style={{ marginTop: "5%" }}
              href="/"
              disabled={!this.props.user}
              className={classes.button}
            >
              Lockers
            </Button>
          </div>
        )}
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapDispatchToProps)(
  withStyles(styles)(withRouter(Login))
);
